import queryString from 'query-string';
import { FilterOperation } from '../components/table/Types';
import { getTsvectorQuery, removeTsvectorQuery } from './tsvectorHelper';
const constantQueries = ['offset', 'size', 'direction', 'sort'];
export const changeQueryFilter = (query, filter, offset) => (Object.assign(Object.assign({}, query), { offset: offset || 0, filter: [...(query.filter || []).filter((f) => f.field !== filter.field), filter] }));
export const updateQueryFilter = (query, filter) => (Object.assign(Object.assign({}, query), { filter: [...(query.filter || []).filter((f) => f.field !== filter.field), filter] }));
export const removeQueryFilter = (query, field) => (Object.assign(Object.assign({}, query), { filter: (query.filter || []).filter((f) => f.field !== field) }));
export const removeQueryFilterValue = (query, field, value) => {
    const current = getQueryFilter(query, field);
    if (Array.isArray(current.val)) {
        current.val = current.val.filter((c) => c !== value);
        const currentFilters = (query.filter || []).filter((f) => f.field !== field);
        if (current.val.length) {
            currentFilters.push(current);
        }
        return Object.assign(Object.assign({}, query), { filter: currentFilters });
    }
    if (current.val === value) {
        return removeQueryFilter(query, field);
    }
    return query;
};
export const clearQueryFilters = (query, defaultQuery = {}) => {
    // eslint-disable-next-line no-param-reassign
    delete query.filter;
    // eslint-disable-next-line no-param-reassign
    delete query.search;
    return Object.assign(Object.assign({}, defaultQuery), query);
};
export const filteredByUser = (query, defaultQuery = {}) => (query.filter || []).length !== (defaultQuery.filter || []).length || !!query.search;
export const getQueryFilter = (query, field) => (Object.assign({}, ((!!query.filter && query.filter.find((f) => f.field === field)) || {})));
export const decodeQueryToUrlSearch = (query, defaultQuery = {}) => {
    const urlQuery = {};
    Object.keys(query).forEach((key) => {
        const param = query[key];
        if (!param)
            return;
        if (!!defaultQuery[key] && defaultQuery[key] === param)
            return;
        if (constantQueries.includes(key)) {
            urlQuery[key] = param;
        }
        else if (key === 'search') {
            urlQuery[key] = removeTsvectorQuery(param);
        }
        else if (key === 'filter' && !!param.length) {
            param.forEach((filter) => {
                if (!!defaultQuery.filter && defaultQuery.filter.some((f) => f.field === filter.field && f.val === filter.val))
                    return;
                const value = 
                // eslint-disable-next-line no-nested-ternary
                Array.isArray(filter.val) && !!filter.val.length
                    ? typeof filter.val[0] === 'string' || typeof filter.val[0] === 'number'
                        ? filter.val
                        : filter.val.reduce((a, currentValue) => [...a, currentValue.id], [])
                    : filter.val;
                if (!!value && !!value.length) {
                    if (Array.isArray(value) && filter.op === FilterOperation.in) {
                        urlQuery[filter.field] = value.join(',');
                    }
                    else if (Array.isArray(value) && filter.op === FilterOperation.between) {
                        urlQuery[filter.field] = value.join('<>');
                    }
                    else {
                        urlQuery[filter.field] = value;
                    }
                }
            });
        }
    });
    const urlSearch = new URLSearchParams(urlQuery).toString();
    return urlSearch ? `?${urlSearch}` : '';
};
export const decodeUrlSearchToQuery = (history, defaultQuery = {}, ignoreParams = []) => {
    let query = Object.assign({}, defaultQuery);
    const urlQuery = queryString.parse(history.location.search);
    Object.keys(urlQuery).forEach((key) => {
        if (constantQueries.includes(key)) {
            if (!ignoreParams.includes(key)) {
                query[key] = urlQuery[key];
            }
        }
        else if (key === 'search') {
            query[key] = getTsvectorQuery(urlQuery[key]);
        }
        else {
            query.filter = query.filter || [];
            if (urlQuery[key].split(',').length > 1) {
                query = changeQueryFilter(query, {
                    field: key,
                    op: FilterOperation.in,
                    val: urlQuery[key].split(','),
                });
            }
            else if (urlQuery[key].split('<>').length > 1) {
                query = changeQueryFilter(query, {
                    field: key,
                    op: FilterOperation.between,
                    val: urlQuery[key].split('<>'),
                });
            }
            else if (key === 'assignee' ||
                key === 'location' ||
                key === 'mapped_controls' ||
                key === 'service_role' ||
                key === 'account' ||
                key === 'master_risk_category') {
                query = changeQueryFilter(query, {
                    field: key,
                    op: FilterOperation.in,
                    val: urlQuery[key],
                });
            }
            else {
                query = changeQueryFilter(query, {
                    field: key,
                    op: FilterOperation.eq,
                    val: urlQuery[key],
                });
            }
        }
    });
    return query;
};
export const decodeUrlEsSearch = (url) => {
    const decoded = queryString.parse(url).search;
    if (typeof decoded === 'string' && !!decoded) {
        return decoded;
    }
    return '';
};
export const formatLocationFilter = (filters) => {
    if (filters.length) {
        filters.forEach((filter) => {
            // We have a single location being filtered
            if (filter.field === 'location' && filter.op === FilterOperation.eq) {
                // eslint-disable-next-line no-param-reassign
                filter.op = FilterOperation.in;
                // eslint-disable-next-line no-param-reassign
                filter.val = [filter.val];
            }
        });
    }
    return filters;
};
